/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UserUProfileIndexRouteImport } from './routes/_user/u/profile/index'
import { Route as UserUDashboardIndexRouteImport } from './routes/_user/u/dashboard/index'
import { Route as UserUAuthenticationIndexRouteImport } from './routes/_user/u/authentication/index'
import { Route as UserUTailscaleLoginAccessPlannedRouteImport } from './routes/_user/u/tailscale-login/access-planned'
import { Route as UserUTailscaleLoginAccessExpiredRouteImport } from './routes/_user/u/tailscale-login/access-expired'
import { Route as StaticSTailscaleLoginSplatRouteImport } from './routes/_static/s/tailscale-login/$'
import { Route as StaticSLoginSuccessRouteImport } from './routes/_static/s/login/success'
import { Route as StaticSLoginServerErrorRouteImport } from './routes/_static/s/login/server-error'
import { Route as StaticSLoginOutdatedRouteImport } from './routes/_static/s/login/outdated'
import { Route as StaticSLoginInvalidUrlRouteImport } from './routes/_static/s/login/invalid-url'
import { Route as StaticSLoginInvalidCsrfRouteImport } from './routes/_static/s/login/invalid-csrf'
import { Route as StaticSLoginDisabledRouteImport } from './routes/_static/s/login/disabled'
import { Route as UserUTailscaleLoginTokenIndexRouteImport } from './routes/_user/u/tailscale-login/$token.index'
import { Route as StaticSLoginTokenIndexRouteImport } from './routes/_static/s/login/$token/index'

const UserLazyRouteImport = createFileRoute('/_user')()
const StaticLazyRouteImport = createFileRoute('/_static')()
const StaticSInviteInviteIdLazyRouteImport = createFileRoute(
  '/_static/s/invite/$inviteId',
)()

const UserLazyRoute = UserLazyRouteImport.update({
  id: '/_user',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_user.lazy').then((d) => d.Route))
const StaticLazyRoute = StaticLazyRouteImport.update({
  id: '/_static',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_static.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserUProfileIndexRoute = UserUProfileIndexRouteImport.update({
  id: '/u/profile/',
  path: '/u/profile/',
  getParentRoute: () => UserLazyRoute,
} as any)
const UserUDashboardIndexRoute = UserUDashboardIndexRouteImport.update({
  id: '/u/dashboard/',
  path: '/u/dashboard/',
  getParentRoute: () => UserLazyRoute,
} as any)
const UserUAuthenticationIndexRoute =
  UserUAuthenticationIndexRouteImport.update({
    id: '/u/authentication/',
    path: '/u/authentication/',
    getParentRoute: () => UserLazyRoute,
  } as any)
const StaticSInviteInviteIdLazyRoute =
  StaticSInviteInviteIdLazyRouteImport.update({
    id: '/s/invite/$inviteId',
    path: '/s/invite/$inviteId',
    getParentRoute: () => StaticLazyRoute,
  } as any).lazy(() =>
    import('./routes/_static/s/invite/$inviteId.lazy').then((d) => d.Route),
  )
const UserUTailscaleLoginAccessPlannedRoute =
  UserUTailscaleLoginAccessPlannedRouteImport.update({
    id: '/u/tailscale-login/access-planned',
    path: '/u/tailscale-login/access-planned',
    getParentRoute: () => UserLazyRoute,
  } as any)
const UserUTailscaleLoginAccessExpiredRoute =
  UserUTailscaleLoginAccessExpiredRouteImport.update({
    id: '/u/tailscale-login/access-expired',
    path: '/u/tailscale-login/access-expired',
    getParentRoute: () => UserLazyRoute,
  } as any)
const StaticSTailscaleLoginSplatRoute =
  StaticSTailscaleLoginSplatRouteImport.update({
    id: '/s/tailscale-login/$',
    path: '/s/tailscale-login/$',
    getParentRoute: () => StaticLazyRoute,
  } as any)
const StaticSLoginSuccessRoute = StaticSLoginSuccessRouteImport.update({
  id: '/s/login/success',
  path: '/s/login/success',
  getParentRoute: () => StaticLazyRoute,
} as any)
const StaticSLoginServerErrorRoute = StaticSLoginServerErrorRouteImport.update({
  id: '/s/login/server-error',
  path: '/s/login/server-error',
  getParentRoute: () => StaticLazyRoute,
} as any)
const StaticSLoginOutdatedRoute = StaticSLoginOutdatedRouteImport.update({
  id: '/s/login/outdated',
  path: '/s/login/outdated',
  getParentRoute: () => StaticLazyRoute,
} as any)
const StaticSLoginInvalidUrlRoute = StaticSLoginInvalidUrlRouteImport.update({
  id: '/s/login/invalid-url',
  path: '/s/login/invalid-url',
  getParentRoute: () => StaticLazyRoute,
} as any)
const StaticSLoginInvalidCsrfRoute = StaticSLoginInvalidCsrfRouteImport.update({
  id: '/s/login/invalid-csrf',
  path: '/s/login/invalid-csrf',
  getParentRoute: () => StaticLazyRoute,
} as any)
const StaticSLoginDisabledRoute = StaticSLoginDisabledRouteImport.update({
  id: '/s/login/disabled',
  path: '/s/login/disabled',
  getParentRoute: () => StaticLazyRoute,
} as any)
const UserUTailscaleLoginTokenIndexRoute =
  UserUTailscaleLoginTokenIndexRouteImport.update({
    id: '/u/tailscale-login/$token/',
    path: '/u/tailscale-login/$token/',
    getParentRoute: () => UserLazyRoute,
  } as any)
const StaticSLoginTokenIndexRoute = StaticSLoginTokenIndexRouteImport.update({
  id: '/s/login/$token/',
  path: '/s/login/$token/',
  getParentRoute: () => StaticLazyRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/s/login/disabled': typeof StaticSLoginDisabledRoute
  '/s/login/invalid-csrf': typeof StaticSLoginInvalidCsrfRoute
  '/s/login/invalid-url': typeof StaticSLoginInvalidUrlRoute
  '/s/login/outdated': typeof StaticSLoginOutdatedRoute
  '/s/login/server-error': typeof StaticSLoginServerErrorRoute
  '/s/login/success': typeof StaticSLoginSuccessRoute
  '/s/tailscale-login/$': typeof StaticSTailscaleLoginSplatRoute
  '/u/tailscale-login/access-expired': typeof UserUTailscaleLoginAccessExpiredRoute
  '/u/tailscale-login/access-planned': typeof UserUTailscaleLoginAccessPlannedRoute
  '/s/invite/$inviteId': typeof StaticSInviteInviteIdLazyRoute
  '/u/authentication/': typeof UserUAuthenticationIndexRoute
  '/u/dashboard/': typeof UserUDashboardIndexRoute
  '/u/profile/': typeof UserUProfileIndexRoute
  '/s/login/$token/': typeof StaticSLoginTokenIndexRoute
  '/u/tailscale-login/$token/': typeof UserUTailscaleLoginTokenIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/s/login/disabled': typeof StaticSLoginDisabledRoute
  '/s/login/invalid-csrf': typeof StaticSLoginInvalidCsrfRoute
  '/s/login/invalid-url': typeof StaticSLoginInvalidUrlRoute
  '/s/login/outdated': typeof StaticSLoginOutdatedRoute
  '/s/login/server-error': typeof StaticSLoginServerErrorRoute
  '/s/login/success': typeof StaticSLoginSuccessRoute
  '/s/tailscale-login/$': typeof StaticSTailscaleLoginSplatRoute
  '/u/tailscale-login/access-expired': typeof UserUTailscaleLoginAccessExpiredRoute
  '/u/tailscale-login/access-planned': typeof UserUTailscaleLoginAccessPlannedRoute
  '/s/invite/$inviteId': typeof StaticSInviteInviteIdLazyRoute
  '/u/authentication': typeof UserUAuthenticationIndexRoute
  '/u/dashboard': typeof UserUDashboardIndexRoute
  '/u/profile': typeof UserUProfileIndexRoute
  '/s/login/$token': typeof StaticSLoginTokenIndexRoute
  '/u/tailscale-login/$token': typeof UserUTailscaleLoginTokenIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_static': typeof StaticLazyRouteWithChildren
  '/_user': typeof UserLazyRouteWithChildren
  '/_static/s/login/disabled': typeof StaticSLoginDisabledRoute
  '/_static/s/login/invalid-csrf': typeof StaticSLoginInvalidCsrfRoute
  '/_static/s/login/invalid-url': typeof StaticSLoginInvalidUrlRoute
  '/_static/s/login/outdated': typeof StaticSLoginOutdatedRoute
  '/_static/s/login/server-error': typeof StaticSLoginServerErrorRoute
  '/_static/s/login/success': typeof StaticSLoginSuccessRoute
  '/_static/s/tailscale-login/$': typeof StaticSTailscaleLoginSplatRoute
  '/_user/u/tailscale-login/access-expired': typeof UserUTailscaleLoginAccessExpiredRoute
  '/_user/u/tailscale-login/access-planned': typeof UserUTailscaleLoginAccessPlannedRoute
  '/_static/s/invite/$inviteId': typeof StaticSInviteInviteIdLazyRoute
  '/_user/u/authentication/': typeof UserUAuthenticationIndexRoute
  '/_user/u/dashboard/': typeof UserUDashboardIndexRoute
  '/_user/u/profile/': typeof UserUProfileIndexRoute
  '/_static/s/login/$token/': typeof StaticSLoginTokenIndexRoute
  '/_user/u/tailscale-login/$token/': typeof UserUTailscaleLoginTokenIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/s/login/disabled'
    | '/s/login/invalid-csrf'
    | '/s/login/invalid-url'
    | '/s/login/outdated'
    | '/s/login/server-error'
    | '/s/login/success'
    | '/s/tailscale-login/$'
    | '/u/tailscale-login/access-expired'
    | '/u/tailscale-login/access-planned'
    | '/s/invite/$inviteId'
    | '/u/authentication/'
    | '/u/dashboard/'
    | '/u/profile/'
    | '/s/login/$token/'
    | '/u/tailscale-login/$token/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/s/login/disabled'
    | '/s/login/invalid-csrf'
    | '/s/login/invalid-url'
    | '/s/login/outdated'
    | '/s/login/server-error'
    | '/s/login/success'
    | '/s/tailscale-login/$'
    | '/u/tailscale-login/access-expired'
    | '/u/tailscale-login/access-planned'
    | '/s/invite/$inviteId'
    | '/u/authentication'
    | '/u/dashboard'
    | '/u/profile'
    | '/s/login/$token'
    | '/u/tailscale-login/$token'
  id:
    | '__root__'
    | '/'
    | '/_static'
    | '/_user'
    | '/_static/s/login/disabled'
    | '/_static/s/login/invalid-csrf'
    | '/_static/s/login/invalid-url'
    | '/_static/s/login/outdated'
    | '/_static/s/login/server-error'
    | '/_static/s/login/success'
    | '/_static/s/tailscale-login/$'
    | '/_user/u/tailscale-login/access-expired'
    | '/_user/u/tailscale-login/access-planned'
    | '/_static/s/invite/$inviteId'
    | '/_user/u/authentication/'
    | '/_user/u/dashboard/'
    | '/_user/u/profile/'
    | '/_static/s/login/$token/'
    | '/_user/u/tailscale-login/$token/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  StaticLazyRoute: typeof StaticLazyRouteWithChildren
  UserLazyRoute: typeof UserLazyRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_user': {
      id: '/_user'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof UserLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_static': {
      id: '/_static'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof StaticLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_user/u/profile/': {
      id: '/_user/u/profile/'
      path: '/u/profile'
      fullPath: '/u/profile/'
      preLoaderRoute: typeof UserUProfileIndexRouteImport
      parentRoute: typeof UserLazyRoute
    }
    '/_user/u/dashboard/': {
      id: '/_user/u/dashboard/'
      path: '/u/dashboard'
      fullPath: '/u/dashboard/'
      preLoaderRoute: typeof UserUDashboardIndexRouteImport
      parentRoute: typeof UserLazyRoute
    }
    '/_user/u/authentication/': {
      id: '/_user/u/authentication/'
      path: '/u/authentication'
      fullPath: '/u/authentication/'
      preLoaderRoute: typeof UserUAuthenticationIndexRouteImport
      parentRoute: typeof UserLazyRoute
    }
    '/_static/s/invite/$inviteId': {
      id: '/_static/s/invite/$inviteId'
      path: '/s/invite/$inviteId'
      fullPath: '/s/invite/$inviteId'
      preLoaderRoute: typeof StaticSInviteInviteIdLazyRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_user/u/tailscale-login/access-planned': {
      id: '/_user/u/tailscale-login/access-planned'
      path: '/u/tailscale-login/access-planned'
      fullPath: '/u/tailscale-login/access-planned'
      preLoaderRoute: typeof UserUTailscaleLoginAccessPlannedRouteImport
      parentRoute: typeof UserLazyRoute
    }
    '/_user/u/tailscale-login/access-expired': {
      id: '/_user/u/tailscale-login/access-expired'
      path: '/u/tailscale-login/access-expired'
      fullPath: '/u/tailscale-login/access-expired'
      preLoaderRoute: typeof UserUTailscaleLoginAccessExpiredRouteImport
      parentRoute: typeof UserLazyRoute
    }
    '/_static/s/tailscale-login/$': {
      id: '/_static/s/tailscale-login/$'
      path: '/s/tailscale-login/$'
      fullPath: '/s/tailscale-login/$'
      preLoaderRoute: typeof StaticSTailscaleLoginSplatRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_static/s/login/success': {
      id: '/_static/s/login/success'
      path: '/s/login/success'
      fullPath: '/s/login/success'
      preLoaderRoute: typeof StaticSLoginSuccessRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_static/s/login/server-error': {
      id: '/_static/s/login/server-error'
      path: '/s/login/server-error'
      fullPath: '/s/login/server-error'
      preLoaderRoute: typeof StaticSLoginServerErrorRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_static/s/login/outdated': {
      id: '/_static/s/login/outdated'
      path: '/s/login/outdated'
      fullPath: '/s/login/outdated'
      preLoaderRoute: typeof StaticSLoginOutdatedRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_static/s/login/invalid-url': {
      id: '/_static/s/login/invalid-url'
      path: '/s/login/invalid-url'
      fullPath: '/s/login/invalid-url'
      preLoaderRoute: typeof StaticSLoginInvalidUrlRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_static/s/login/invalid-csrf': {
      id: '/_static/s/login/invalid-csrf'
      path: '/s/login/invalid-csrf'
      fullPath: '/s/login/invalid-csrf'
      preLoaderRoute: typeof StaticSLoginInvalidCsrfRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_static/s/login/disabled': {
      id: '/_static/s/login/disabled'
      path: '/s/login/disabled'
      fullPath: '/s/login/disabled'
      preLoaderRoute: typeof StaticSLoginDisabledRouteImport
      parentRoute: typeof StaticLazyRoute
    }
    '/_user/u/tailscale-login/$token/': {
      id: '/_user/u/tailscale-login/$token/'
      path: '/u/tailscale-login/$token'
      fullPath: '/u/tailscale-login/$token/'
      preLoaderRoute: typeof UserUTailscaleLoginTokenIndexRouteImport
      parentRoute: typeof UserLazyRoute
    }
    '/_static/s/login/$token/': {
      id: '/_static/s/login/$token/'
      path: '/s/login/$token'
      fullPath: '/s/login/$token/'
      preLoaderRoute: typeof StaticSLoginTokenIndexRouteImport
      parentRoute: typeof StaticLazyRoute
    }
  }
}

interface StaticLazyRouteChildren {
  StaticSLoginDisabledRoute: typeof StaticSLoginDisabledRoute
  StaticSLoginInvalidCsrfRoute: typeof StaticSLoginInvalidCsrfRoute
  StaticSLoginInvalidUrlRoute: typeof StaticSLoginInvalidUrlRoute
  StaticSLoginOutdatedRoute: typeof StaticSLoginOutdatedRoute
  StaticSLoginServerErrorRoute: typeof StaticSLoginServerErrorRoute
  StaticSLoginSuccessRoute: typeof StaticSLoginSuccessRoute
  StaticSTailscaleLoginSplatRoute: typeof StaticSTailscaleLoginSplatRoute
  StaticSInviteInviteIdLazyRoute: typeof StaticSInviteInviteIdLazyRoute
  StaticSLoginTokenIndexRoute: typeof StaticSLoginTokenIndexRoute
}

const StaticLazyRouteChildren: StaticLazyRouteChildren = {
  StaticSLoginDisabledRoute: StaticSLoginDisabledRoute,
  StaticSLoginInvalidCsrfRoute: StaticSLoginInvalidCsrfRoute,
  StaticSLoginInvalidUrlRoute: StaticSLoginInvalidUrlRoute,
  StaticSLoginOutdatedRoute: StaticSLoginOutdatedRoute,
  StaticSLoginServerErrorRoute: StaticSLoginServerErrorRoute,
  StaticSLoginSuccessRoute: StaticSLoginSuccessRoute,
  StaticSTailscaleLoginSplatRoute: StaticSTailscaleLoginSplatRoute,
  StaticSInviteInviteIdLazyRoute: StaticSInviteInviteIdLazyRoute,
  StaticSLoginTokenIndexRoute: StaticSLoginTokenIndexRoute,
}

const StaticLazyRouteWithChildren = StaticLazyRoute._addFileChildren(
  StaticLazyRouteChildren,
)

interface UserLazyRouteChildren {
  UserUTailscaleLoginAccessExpiredRoute: typeof UserUTailscaleLoginAccessExpiredRoute
  UserUTailscaleLoginAccessPlannedRoute: typeof UserUTailscaleLoginAccessPlannedRoute
  UserUAuthenticationIndexRoute: typeof UserUAuthenticationIndexRoute
  UserUDashboardIndexRoute: typeof UserUDashboardIndexRoute
  UserUProfileIndexRoute: typeof UserUProfileIndexRoute
  UserUTailscaleLoginTokenIndexRoute: typeof UserUTailscaleLoginTokenIndexRoute
}

const UserLazyRouteChildren: UserLazyRouteChildren = {
  UserUTailscaleLoginAccessExpiredRoute: UserUTailscaleLoginAccessExpiredRoute,
  UserUTailscaleLoginAccessPlannedRoute: UserUTailscaleLoginAccessPlannedRoute,
  UserUAuthenticationIndexRoute: UserUAuthenticationIndexRoute,
  UserUDashboardIndexRoute: UserUDashboardIndexRoute,
  UserUProfileIndexRoute: UserUProfileIndexRoute,
  UserUTailscaleLoginTokenIndexRoute: UserUTailscaleLoginTokenIndexRoute,
}

const UserLazyRouteWithChildren = UserLazyRoute._addFileChildren(
  UserLazyRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  StaticLazyRoute: StaticLazyRouteWithChildren,
  UserLazyRoute: UserLazyRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
